exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#test pre{font-size:10px;background:#f4f4f4;padding:1rem;margin-top:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-460da2ce!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Developer/Developer.vue
// module id = 284
// module chunks = 0